export class CompanyScheduleOfInvestments {
  companyName: string;
  companyId: number;
  investmentSOI: SoiPart;
  unrealizedSOI: SoiPart;
  realizedSOI: SoiPart;

  constructor(companyName: string,
    companyId: number,
    investmentSOI: SoiPart,
    unrealizedSOI: SoiPart,
    realizedSOI: SoiPart) {
    this.companyName = companyName;
    this.companyId = companyId;
    this.investmentSOI = investmentSOI;
    this.unrealizedSOI = unrealizedSOI;
    this.realizedSOI = realizedSOI;
  }
}

export class SoiPart {
  accountNumPort: string;
  accountNumBook: string;
  portfolio = 0;
  books = 0;

  constructor(accountNumPort: string, accountNumBook?: string) {
    this.accountNumPort = accountNumPort;
    this.accountNumBook = accountNumBook === '- + -' ? '-' : accountNumBook;
  }

  setPortfolio(value: number) {
    this.portfolio = Number(value.toFixed(0));
  }

  setBooks(value: number) {
    this.books = Number(value.toFixed(0));
  }
}

export interface DifferenceAdjustmentObject{
  accountCode: string;
  value: number;
}
